import api from '@/services/api'

export default () => !!api.clientData('is_identity_verified')